import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * TODO: relay to query for the current list of ids based on the applied params
 */
export const executeLoad = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    feature.actions.load.relay(
      forwardTo =>
        feature.selectors.queryRequest.asObservable.pipe(
          rxjs.take(1),
          rxjs.map(params =>
            forwardTo(
              plugin.collection.plugins.dataOperationPlugin.feature.actions
                .list,
              {
                input: params,
                output: ({ response }) => ({
                  ids: response.entities.map(entity =>
                    plugin.collection.identify(entity),
                  ),
                }),
              },
            ),
          ),
        ),
      // switchMap: if a newer load arrives (e.g. filter applied before the
      // first unfiltered load completes), the previous in-flight load is
      // abandoned so only the latest result ever sets state.ids
      { strategy: 'switch' },
    ).asObservable,
)
